export const getPermissions = (payload?: any) => ({
    type: "@saga/PERMISSION_LIST",
    payload
});